// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"503":"a4adecdb","962":"711b887f"}[chunkId] + ".chunk.css";
};